import { PublicSeminarPageFieldName } from '../gql/graphql';

/**
 * Mapping from PublicSeminarPageFieldName (which is generated from the GQL api and always capslocked) enum values to readable German labels.
 */
export const fieldNameLabels: Record<PublicSeminarPageFieldName, string> = {
  [PublicSeminarPageFieldName.Description_1]: 'Memo 1',
  [PublicSeminarPageFieldName.Description_2]: 'Memo 2',
  [PublicSeminarPageFieldName.Description_3]: 'Memo 3',
  [PublicSeminarPageFieldName.Description_4]: 'Memo 4',
  [PublicSeminarPageFieldName.Description_5]: 'Memo 5',
  [PublicSeminarPageFieldName.FreeText_1]: 'Freier Text 1',
  [PublicSeminarPageFieldName.FreeText_2]: 'Freier Text 2',
  [PublicSeminarPageFieldName.FreeText_3]: 'Freier Text 3',
  [PublicSeminarPageFieldName.FreeText_4]: 'Freier Text 4',
  [PublicSeminarPageFieldName.FreeText_5]: 'Freier Text 5',
  [PublicSeminarPageFieldName.MetaText_1]: 'Rechtsträger',
  [PublicSeminarPageFieldName.MetaText_2]: 'Kostenträger',
  [PublicSeminarPageFieldName.MetaText_3]: 'Seminartyp',
  [PublicSeminarPageFieldName.MetaText_4]: 'Kurstyp',
  [PublicSeminarPageFieldName.MetaText_5]: 'Gruppenbezeichnung',
  [PublicSeminarPageFieldName.Material]: 'Material',
  [PublicSeminarPageFieldName.Prerequisites]: 'Voraussetzungen',
  [PublicSeminarPageFieldName.OrganizationalNotes]: 'Organisation',
  [PublicSeminarPageFieldName.ShortDescription]: 'Kurzbeschreibung',
  [PublicSeminarPageFieldName.Title]: 'Titel',
  [PublicSeminarPageFieldName.Subtitle]: 'Untertitel',
  [PublicSeminarPageFieldName.LocationText]: 'Ort',
  [PublicSeminarPageFieldName.InfoNotice]: 'Bemerkung',
  [PublicSeminarPageFieldName.WebinarLink]: 'Link zur Onlineveranstaltung',
  [PublicSeminarPageFieldName.InformationExtern]: 'Öffentliche Informationen',
};

export const fieldNameToReadableName = (
  fieldName?: PublicSeminarPageFieldName | null,
): string => {
  return fieldName ? fieldNameLabels[fieldName] : '';
};

/**
 * Mapping from seminar entity property names (used as form field names) to readable labels.
 * Based on the backend FieldName enum mapping.
 */
export const formFieldLabels: Record<string, string> = {
  title: fieldNameLabels[PublicSeminarPageFieldName.Title],
  subtitle: fieldNameLabels[PublicSeminarPageFieldName.Subtitle],
  description: fieldNameLabels[PublicSeminarPageFieldName.Description_1],
  description2: fieldNameLabels[PublicSeminarPageFieldName.Description_2],
  description3: fieldNameLabels[PublicSeminarPageFieldName.Description_3],
  description4: fieldNameLabels[PublicSeminarPageFieldName.Description_4],
  description5: fieldNameLabels[PublicSeminarPageFieldName.Description_5],
  locationText: fieldNameLabels[PublicSeminarPageFieldName.LocationText],
  infoNotice: fieldNameLabels[PublicSeminarPageFieldName.InfoNotice],
  freetext1: fieldNameLabels[PublicSeminarPageFieldName.FreeText_1],
  freetext2: fieldNameLabels[PublicSeminarPageFieldName.FreeText_2],
  freetext3: fieldNameLabels[PublicSeminarPageFieldName.FreeText_3],
  freetext4: fieldNameLabels[PublicSeminarPageFieldName.FreeText_4],
  freetext5: fieldNameLabels[PublicSeminarPageFieldName.FreeText_5],
  metaText1: fieldNameLabels[PublicSeminarPageFieldName.MetaText_1],
  metaText2: fieldNameLabels[PublicSeminarPageFieldName.MetaText_2],
  metaText3: fieldNameLabels[PublicSeminarPageFieldName.MetaText_3],
  metaText4: fieldNameLabels[PublicSeminarPageFieldName.MetaText_4],
  metaText5: fieldNameLabels[PublicSeminarPageFieldName.MetaText_5],
  material: fieldNameLabels[PublicSeminarPageFieldName.Material],
  prerequisites: fieldNameLabels[PublicSeminarPageFieldName.Prerequisites],
  organizationalNotes:
    fieldNameLabels[PublicSeminarPageFieldName.OrganizationalNotes],
  shortDescription:
    fieldNameLabels[PublicSeminarPageFieldName.ShortDescription],
  webinarLink: fieldNameLabels[PublicSeminarPageFieldName.WebinarLink],
  informationExtern:
    fieldNameLabels[PublicSeminarPageFieldName.InformationExtern],
};
